import React from "react";

class TopNav extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { menu_is_active: false };
  }

  render() {
    return (
      <nav
        className="navbar only-mobile"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand navbar-blue">
          <a
            role="button"
            className={`navbar-burger navbar-burger-blue ${
              this.state.menu_is_active ? "is-active" : ""
            }`}
            onClick={() =>
              this.setState({ menu_is_active: !this.state.menu_is_active })
            }
            aria-label="menu"
            aria-expanded="false"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
          <a className="navbar-item-logo" href="/">
            <img src="https://statichouse.pacefi.com/logos/Logo_CleanFi-hor-greenwhite.png"/>
          </a>
          <a
            className="navbar-item logout-button"
            style={{ marginLeft: "-2em", pointerEvents: "none" }}
          >
            Log out
          </a>
        </div>
        <div
          className={`navbar-menu ${
            this.state.menu_is_active ? "is-active" : ""
          }`}
        >
          <div className="navbar-end">
            <a className="navbar-item has-text-primary">About CleanFi</a>
          </div>
        </div>
      </nav>
    );
  }
}

export default TopNav;
